import { Spin } from 'antd'

import type { IdeasRenderParams } from '@/pages/tad.ai/ai-music-generator/_components/Ideas'

import TagSelect from '@/pages/tad.ai/ai-music-generator/_components/TagSelect'

export interface ICreateMusicIdeasProps {
  params: IdeasRenderParams
  className?: string
}

export default function CreateMusicIdeas(props: ICreateMusicIdeasProps) {
  const { params, className } = props

  return (
    <div className={cls`${className}`}>
      <Spin spinning={params.isFetching && !params.hasDisplayableCache}>
        <div className={cls`flex items-center justify-center`}>
          <TagSelect
            tags={params.displayIdeas}
            onChange={params.onSelect}
            listClassName='border-none'
          />
          <CssIcon
            className={cls`i-cus--tad-change text-f-text-quaternary hover:text-f-text size-4 cursor-pointer`}
            onClick={() => {
              params.handleRefresh()
            }}
          />
        </div>
      </Spin>
    </div>
  )
}
